/**
 * Botão Flutuante Oficial do WhatsApp — Unik
 * Integração direta com a estrategista Lara Lívia (+55 31 99537-4661).
 * Design system Genesis Lux com microinteração de pulso e expansão em desktop.
 */
import type { CSSProperties, ReactElement } from "react";

export const UNIK_WHATSAPP_PHONE = "5531995374661";

export function WhatsAppIcon({ className = "h-5 w-5", style }: { className?: string; style?: CSSProperties }): ReactElement {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="currentColor"
      aria-hidden="true"
      className={className}
      style={style}
    >
      <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z" />
    </svg>
  );
}

interface FloatingWhatsAppProps {
  phone?: string;
  message?: string;
  label?: string;
  className?: string;
}

export function FloatingWhatsApp({
  phone = UNIK_WHATSAPP_PHONE,
  message = "Olá Lara! Gostaria de falar sobre o briefing da Unik.",
  label = "Falar com a Lara",
  className = "",
}: FloatingWhatsAppProps): ReactElement {
  const url = `https://wa.me/${phone}?text=${encodeURIComponent(message)}`;

  return (
    <aside
      aria-label="Atendimento via WhatsApp"
      className={`fixed bottom-6 right-6 sm:bottom-8 sm:right-8 z-[90] flex items-center ${className}`}
    >
      <a
        href={url}
        target="_blank"
        rel="noreferrer"
        aria-label={label}
        className="group relative flex items-center gap-2.5 rounded-full bg-[#25D366] text-white px-3.5 py-3.5 sm:px-4 sm:py-3.5 shadow-[0_8px_25px_rgba(0,0,0,0.5),0_0_20px_rgba(37,211,102,0.35)] hover:bg-[#20ba59] hover:shadow-[0_10px_30px_rgba(0,0,0,0.6),0_0_28px_rgba(37,211,102,0.55)] hover:scale-105 active:scale-95 transition-all duration-300 ease-out focus:outline-none focus:ring-2 focus:ring-[#25D366] focus:ring-offset-2 focus:ring-offset-surface-base"
      >
        {/* Anel de pulso sutil em repouso */}
        <span
          className="pointer-events-none absolute -inset-1 rounded-full bg-[#25D366]/30 animate-ping opacity-60"
          style={{ animationDuration: "3s" }}
          aria-hidden="true"
        />

        {/* Ícone oficial */}
        <WhatsAppIcon className="relative h-6 w-6 text-white shrink-0 drop-shadow-sm" />

        {/* Label descritivo no desktop com tipografia Genesis Lux */}
        {label && (
          <span className="relative hidden sm:inline-block font-sans text-xs font-semibold tracking-wide text-white drop-shadow-sm select-none pr-1">
            {label}
          </span>
        )}
      </a>
    </aside>
  );
}
